import React from "react";
import { BsQuestionCircle } from "react-icons/bs";
import "./Tooltip.css";

const Tooltip = ({ content, tooltipClass = "", iconClass = "", wrapperClass = "" }) => {
  if (!content) return null;
  return (
    <div className={`reusable-tooltip-wrapper ${wrapperClass}`}>
      <BsQuestionCircle className={`reusable-tooltip-icon ${iconClass}`} />
      <div className={`reusable-tooltip-popup ${tooltipClass}`}>
        <div className="reusable-tooltip-content">
          {content}
        </div>
      </div>
    </div>
  );
};

export default Tooltip;
